"use strict";

var DATE_TIME = 'Y-m-d H:i';
var DATE      = 'Y-m-d';
  
FlatpickrDirective.$inject = [];
function FlatpickrDirective() {
  return {
    require: '^ngModel',
    restrict : 'A',
    scope : {
      dateOnly: "=",
      minDate: "=",
      maxDate: "="
    },
    link : function(scope, element, attrs, ngModel) {
      var el        = element[0];
      var flatpickr = require("flatpickr");
      flatpickr.init.prototype.l10n.firstDayOfWeek = 1;
      flatpickr.init.prototype.l10n.weekdays = {
        shorthand: ['Sön', 'Mån', 'Tis', 'Ons', 'Tors', 'Fre', 'Lör'],
        longhand: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],         
      };
      flatpickr.init.prototype.l10n.months = {
        shorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
        longhand: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
      };
      var vp;

      function dateIsEqual(a, b) {
        if(a instanceof Date && b instanceof Date) {
          return a.getTime() === b.getTime();
        }

        return false;
      }

      function options(dateOnly) {
        return {
          defaultDate: new Date(ngModel.$modelValue),
          dateFormat:  dateOnly ? DATE : DATE_TIME,
          enableTime:  !dateOnly,
          time_24hr:   true,
          minDate: angular.isDefined(scope.minDate) ? new Date(scope.minDate) : null,
          maxDate: angular.isDefined(scope.maxDate) ? new Date(scope.maxDate) : null,
          onChange:    function() {
            scope.$apply(function() {
              ngModel.$setViewValue(vp.selectedDateObj);
            });
          }
        };
      }

      ngModel.$render = function() {
        if(!vp) {
          // Flatpickr needs to have a defaultDate all the time, or it will default to 12:00
          // so we wait until we actually try to render before we create the Flatpickr
          vp = flatpickr(el, options(scope.dateOnly));

          scope.$watch('dateOnly', function(dateOnly, old) {
            if(dateOnly !== old) {
              // Reinitialize to make flatpickr recreate the picker
              vp = flatpickr(el, options(dateOnly));
            }
          });
          scope.$watch("[minDate,maxDate]", function(newValue, oldValue){
            if ((newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0])) || (newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1]))) {
              vp = flatpickr(el, options(scope.dateOnly));
            }
          });
        } else {
          if (ngModel.$modelValue !== null) {
            // defaultDate is used to read the time from
            vp.set("defaultDate", new Date(ngModel.$modelValue));
            // Then we set the date to update it
            vp.setDate(new Date(ngModel.$modelValue));
            if (!scope.dateOnly) {
              vp.setTime(ngModel.$modelValue.getHours(), ngModel.$modelValue.getMinutes());
            }
          }
        }
      };
    }
  };
}

angular.module('dokiv')
  .directive('ngFlatpickr', [FlatpickrDirective]);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/AngularFlatpickr.js
// module id = 235
// module chunks = 0